import { useCallback, useEffect, useRef } from "react";

export const DEFAULT_RESULTS_PAGE_SIZE = 20;
export const RESULTS_SCROLL_THRESHOLD_PX = 512;

export function isNearResultsListBottom(
  element,
  thresholdPx = RESULTS_SCROLL_THRESHOLD_PX,
) {
  if (!element) return false;

  const distanceFromBottom =
    element.scrollHeight - element.scrollTop - element.clientHeight;

  return distanceFromBottom <= thresholdPx;
}

export function useInfiniteResultsPageSize({
  canLoadMore,
  loading,
  loadingMore,
  rowsLength,
  resetKey,
  pageSize,
  setPageSize,
  initialPageSize = DEFAULT_RESULTS_PAGE_SIZE,
  pageSizeStep = DEFAULT_RESULTS_PAGE_SIZE,
  thresholdPx = RESULTS_SCROLL_THRESHOLD_PX,
}) {
  const pendingRequestRef = useRef(false);

  useEffect(() => {
    setPageSize(initialPageSize);
    pendingRequestRef.current = false;
  }, [initialPageSize, resetKey, setPageSize]);

  useEffect(() => {
    if (!pendingRequestRef.current) return;

    if (!loadingMore && (!canLoadMore || rowsLength >= pageSize)) {
      pendingRequestRef.current = false;
    }
  }, [canLoadMore, loadingMore, rowsLength, pageSize]);

  const handleScroll = useCallback(
    (event) => {
      if (pendingRequestRef.current || loading || loadingMore || !canLoadMore) {
        return;
      }

      if (!isNearResultsListBottom(event.currentTarget, thresholdPx)) {
        return;
      }

      pendingRequestRef.current = true;
      setPageSize((currentPageSize) => currentPageSize + pageSizeStep);
    },
    [canLoadMore, loading, loadingMore, pageSizeStep, setPageSize, thresholdPx],
  );

  return { handleScroll };
}
